import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="bg-background py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-173" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-174" data-mp="j76t2jrmpvor">
        <SectionHeading id="summary-title" data-id="element-175" data-mp="j8hw2hd92zet">Everything <span className="text-primary" data-id="element-176" data-mp="j5c6z24mfxj3">Included:</span></SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-xl border border-border bg-background sm:grid-cols-2" data-id="element-177" data-mp="1gu5t94hj5lre">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-border p-4 sm:odd:border-r" data-id="element-178" data-mp="16whkvbr04fqr">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary" data-id="element-179" data-mp="12vpcsltv8gw2">
                <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-180" data-mp="3ro1lf5asvxol" />
              </span>
              <b className="text-sm font-medium text-foreground" data-id="element-181" data-mp="3nkbxmi1y9k4m">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}